import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { moreGamesUpdate } from '~SpectateStore/actions/moreGamesActions';
import { dataPointersUpdate } from '~SpectateStore/actions/dataPointersActions';

export const sportsAdapter = createEntityAdapter();

export const SLICE_NAME = 'sports';

const sports = createSlice({
    name: SLICE_NAME,
    initialState: sportsAdapter.getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { sport } }) => {
                    if (Object.keys(sport).length > 0) {
                        return sportsAdapter.upsertOne(state, sport);
                    }

                    return state;
                },
            )
            .addCase(
                moreGamesUpdate,
                (state, { payload : { sports } }) => {
                    const sport = Object.values(sports || [])[0];

                    if (sport) {
                        sportsAdapter.upsertOne(state, sport);
                    }
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { sports = {} } }) => {
                    if (Object.keys(sports).length > 0) {
                        return sportsAdapter.upsertMany(state, sports);
                    }

                    return state;
                },
            );
    },
});

export default sports.reducer;
